import { Heading } from '@chakra-ui/layout'
import React, { FC } from 'react'

const PageNotFound: FC = () => <Heading>Page not found</Heading>

export default PageNotFound
